import React from 'react'
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';
import ChooseUsSection from './choose_us_section';
import TeamSection from './teamSection';
import UserSection from './userSection';
import AboutSection from './aboutSection';
import { all_routes } from '../../router/all_routes';
import TestimonialSection from '../../home-one/testimonialSection';

const AboutUs = () => {

    const routes = all_routes;

    //Breadcrumb Data
    const breadcrumbs = [
        {
            label: 'About Us',
            link: routes.home1,
            active: false,
        },
        {
            label: 'Pages',
            active: true,
        },
        {
            label: 'About Us',
            active: true,
        },
    ];

    return (
        <div>
            <Breadcrumb
                title="About Us"
                breadcrumbs={breadcrumbs}
                backgroundClass="breadcrumb-bg-01"
            />
            <AboutSection />
            <ChooseUsSection />
            <div className='mt-3'></div>
            <TestimonialSection />
            <div className='mt-5'></div>
        </div>

    )
}

export default AboutUs
